import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import Component from '../components/addItemsToRemoval'
import startActions from '../actions/start'
import orchestratorActions from '../actions/orchestrator'

class Container extends React.Component {

  static displayName = 'AddItemsToRemoval.container'

  continue = () => {
    this.props.open()
  }

  render() {
    return <Component {...this.props} continue={this.continue}/>
  }

  static propTypes = {
    open: PropTypes.func.isRequired,
  }
}

const mapStateToProps = state => {
  const startData = state.ui.remove.start
  const orchestratorData = state.ui.remove.orchestrator
  return {
    show: orchestratorData.get('isActive'),
    items: startData.get('items').toArray(),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    open: () => {
      dispatch(orchestratorActions.setOpen(true))
    },
    removeItem: (itemID) => dispatch(startActions.removeItem(itemID))
    // save: () => dispatch(actions.saveAdd()),
    // modifyTransaction: () => dispatch(actions.modifyTransaction()),
    // setAddress: address => dispatch(actions.setAddress(address)),
    // setFloor: floor => dispatch(actions.setFloor(floor)),
    // setApartment: apartment => dispatch(actions.setApartment(apartment)),
    // setPostalCode: postalCode => dispatch(actions.setPostalCode(postalCode)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/remove/containers/addItemsToRemoval.js